
import { defineComponent } from 'vue'
import Search from '@/components/Search.vue'

export default defineComponent({
  components: {
    Search
  },
  methods: {
    searchByTN (tn: string) {
      this.$router.push({ name: 'Announce By TN', params: { trackingNumber: tn } })
    },
    searchByExportReference (exportReference: string) {
      this.$router.push({ name: 'Announce by Export Reference', params: { exportReference: exportReference } })
    }
  }
})
